import {
  CLEAR_USERS_NOTIFICATION,
  DELETE_USERS_NOTIFICATION,
  GET_CATEGORIES,
  GET_USERS_NOTIFICATION,
  NEW_NOTIFICATION,
  READ_ALL_NOTIFICATION,
  READ_USERS_NOTIFICATION,
  RESET_USERS_NOTIFICATION,
} from "../_actions/types";

const initialState = {
  payload: [],
  loaded: false,
  usersNotifications: [],
  page: 1,
  hasmore: false,
  newNotification: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_CATEGORIES:
      return {
        payload: action.payload,
        loaded: true,
      };
    case GET_USERS_NOTIFICATION:
      return {
        ...state,
        newNotification: false,
        usersNotifications: action.previous
          ? [...state.usersNotifications, ...action.payload]
          : action.payload,
        hasMore: action.loadMore,
        page: action.loadMore ? state.page + 1 : state.page,
      };
    case DELETE_USERS_NOTIFICATION:
      return {
        ...state,
        usersNotifications: state.usersNotifications.filter(
          (item) => action.payload !== item.id
        ),
      };
    case READ_USERS_NOTIFICATION:
      const updateNotification = state.usersNotifications.map((ele) => {
        if (ele.id === action.payload) {
          return { ...ele, is_read: true };
        }
        return ele;
      });
      return {
        ...state,
        usersNotifications: updateNotification,
      };
    case CLEAR_USERS_NOTIFICATION:
      return { ...state, usersNotifications: [] };
    case RESET_USERS_NOTIFICATION:
      return { ...state, page: 1, usersNotifications: [], hasMore: false };
    case NEW_NOTIFICATION:
      return {...state, newNotification: true };
    case READ_ALL_NOTIFICATION:
      const readedNotification = state.usersNotifications.map(ele => ({...ele, is_read: true}))
      return {...state, usersNotifications: readedNotification }
    default:
      return state;
  }
}
